// extracted by mini-css-extract-plugin
module.exports = {"content_login":"login_content_login__1FS0F","bg_login":"login_bg_login__3oBQm","login_detail":"login_login_detail__3I-xp","logo_mobile":"login_logo_mobile__3Re_C"};